import CircleMarker from './markers/CircleMarker';
import SVGMarker from './markers/SVGMarker';

export const DEFAULT_OPTIONS = {
  selector: '.map',
  disableDefaultUI: true,
  zoom: 16
};

class Map {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node for mount google map.
   * @param {Object} center - Object for set lat, lng (latitude, longitude) properties.
   * @param {Array} markers - Array of objects that consist of markers data.
   * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
   * */
  constructor(elementRef, center = { lat: 0, lng: 0 }, markers = [], options = DEFAULT_OPTIONS) {
    this.elementRef = elementRef;
    this.center = this._getCenter(center);
    this.markers = this._getMarkers(markers);
    this.options = options;
    this.map = null;

    this._setup();
  }

  // Private

  /**
   * Set-up the Google map with markers.
   * */
  _setup() {
    this._createMap();
    this._createPinPointOnMapLocation();
    const latLngBounds = new google.maps.LatLngBounds().extend(this.center);
    /* eslint-disable camelcase */
    this.markers.map(m => {
      const { marker, geolocation } = m;
      const { link, image_url, text } = marker;
      const { lat, lng } = geolocation;

      this._drawCircleMarker(lat, lng, link, image_url, text);
      latLngBounds.extend({ lat: lat, lng: lng });
    });

    // this would set zoom of the map to fit all the markers
    this.map.fitBounds(latLngBounds);
  }

  /**
   * Creates the Google map.
   * */
  _createMap() {
    this.map = new google.maps.Map(this.elementRef, {
      center: this.center,
      ...this.options
    });
  }

  /**
   * Set center from data attribute if available, otherwise fallback on the default value
   *
   * @param {Object} defaultCenter - location geocoordinates
   * @return {Object} - location geocoordinates
   * */
  _getCenter(defaultCenter) {
    return (
      this.elementRef.dataset.center ? JSON.parse(this.elementRef.dataset.center) : defaultCenter
    );
  }

  /**
   * Set markers from data attribute if available, otherwise fallback on the default value
   *
   * @param {Object} defaultMarkers - array of map markers
   * @return {Object} - array of map markers
   * */

  _getMarkers(defaultMarkers) {
    return (
      this.elementRef.dataset.markers ? JSON.parse(this.elementRef.dataset.markers) : defaultMarkers
    );
  }

  /**
   * Creates the Google map's marker for map location.
   *
   * @return {Object} - Google map marker object.
   * */
  _createPinPointOnMapLocation() {
    return new google.maps.Marker({
      position: {
        lat: this.center.lat,
        lng: this.center.lng
      },
      map: this.map,
      icon: new SVGMarker().getIcon()
    });
  }

  /**
   * Creates the Google map's "Custom Overlay" for make a circle shape marker.
   *
   * @return {Object} - Google map overlay object.
   * */
  _drawCircleMarker(lat, lng, link, image, text) {
    return new CircleMarker(lat, lng, link, image, this.map, { text: text });
  }
}

export default Map;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/map/index.js